import { TableExtractPtBr } from "./table-extract-pt-br";

export const TABLE_EXTRACT_EN_US: TableExtractPtBr = {
	consolidated: {
		title: "Consolidated Period",
		totalTitle: "Total of period of {{period}}",
		tooltip: "What is the consolidated period?",
		tooltipDescription:
			"Operations grouped by the date when the operation or economic event actually occurred.",
	},
	cashFlow: {
		title: "Transactions of the period",
		totalTitle: "Final Settled Balance of the period",
		tooltip: "What is the transaction summary?",
		tooltipDescription: "Transaction operations performed during the selected period.",
	},
	tpv: {
		title: "Consolidated TPV",
		totalTitle: "Total TPV",
		tooltip: "What is TPV?",
		tooltipDescription:
			"Total transactions processed in the selected period (Terminal Point of Value).",
	},
	total: "Total",
	name: "Description",
	value: "Value",
	grossValue: "Gross Value",
	netValue: "Net Value",
	tax: "Tax",
	from: "From",
	to: "to",
	group: "Group",
	excel: {
		title:
			"Consolidated Report by Transaction Period and Accrual Consolidation {{startDate}} to {{endDate}}",
		fileName: "consolidated_report_transactions_{{startDate}}_to_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Transactions of the period",
	competenceConsolidated: "Accrual Consolidation",
	notLiquidatedTransactions: "Unsettled transactions of the period",
	anticipatedValue: "Anticipated Value",
	obs: "Observation",
};
